import { Role } from "../../../constants/enum";
import { useGlobalState } from "../../../services/context/AuthContext";
import React from "react";
import TopUpRequestByCorporate from "./TopupRequestByCorporate";
import TopupRequestByCorporateUser from "./TopupRequestByCorporateUser";

const TopUpRequest = () => {
  const { userInfo } = useGlobalState();
  return (
    <div>
      {userInfo?.roleName === Role.ADMIN ? (
        <TopUpRequestByCorporate />
      ) : (
        <TopupRequestByCorporateUser />
      )}
    </div>
  );
};

export default TopUpRequest;
